import getChargeData from "../../../../../init/chargedata";
import { isPlainObject } from "../../../../../utils";
import ViewFactory from "../../../helpers/viewfactory";

export default function view() {
  const { $charge } = this;

  const getBillingDataOnce = (() => {
    let done = false;
    let billingData = null;

    return () => {
      if (done !== true && (done = true)) {
        return getChargeData().then($chargeData => {
          try {
            const { billing_metadata: billing } = $chargeData;

            if (isPlainObject(billing)) {
              billingData = Object.create(null);

              Object.keys(billing).forEach(function (field) {
                if (billing[field] !== undefined) {
                    billingData[field] = billing[field];
                }
              });

              Object.freeze(billingData);
            }
          } catch (e) {}

          return billingData;
        });
      }

      return billingData;
    };
  })();

  return (view = ViewFactory({
    NAME: 'PAYPAL_INIT_VIEW',
    constants: { hasBackAction: false },
    next() {
      Promise.resolve(getBillingDataOnce()).then(data => {
        $charge.init({
          data: isPlainObject(data) ? { ...data } : null
        });
      })
    }
  }).call(this));
}
